import React from 'react'

import { Box, useTheme, useMediaQuery } from '@mui/material'

import Logo from '../logo.svg'

import Debugger from './Debugger'
import useFormComponents from './useFormComponents'
import CancelButton from './CancelButton'

const reference = process.env.REACT_APP_DEBUG === '1' ? 'debugged-app' : 'api'

const FormRenderer: React.FC = () => {
  const form = useFormComponents()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '100vh',
      }}
    >
      {process.env.REACT_APP_DEBUG === '1' && <Debugger id={reference} />}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: 3,
          maxWidth: '100%',
          width: 500,
        }}
      >
        {/* the cancel button is provided by the navigation controller in native apps and is not required in the UI */}
        <CancelButton />
        <Box
          mt={isMobile ? 3 : 12}
          mb={6}
          component="img"
          sx={{
            alignSelf: 'center',
          }}
          width={142}
          src={Logo}
          alt="Phillips"
        />
        {form}
      </Box>
    </Box>
  )
}

export default FormRenderer
